import { CheckCircleOutlinedIcon } from '../../../../components';

function PassedIcon() {
  return (
    <span className='bg-success-100 grid h-50 w-50 place-items-center rounded-[50%]'>
      <CheckCircleOutlinedIcon className='text-success-500 text-[100px]' />
    </span>
  );
}

export default PassedIcon;
